import APIClient from '../../../common/APIClient';
import { Cache } from 'aws-amplify';
import { displayError, SUCCESS_ALERT, toggleDialogBox, toggleShowAlert } from '../commonActions';

const SET_REQUEST_BUDGET_FIELD_VALUE = 'SET_REQUEST_BUDGET_FIELD_VALUE';
const FETCH_BUDGET_REQUESTS = 'FETCH_BUDGET_REQUESTS';

export const PENDING = 'Pending Approval';
export const APPROVED = 'Approved';
export const REJECTED = 'Rejected';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const createBudgetRequest = () => {
  return (dispatch, getState) => {
    const requestBudgetValues = getState().budgetRequests.requestBudgetHours;
    Object.assign(requestBudgetValues, {user_id: Cache.getItem('userId'), status: PENDING})
  
    client().post(
      'budget-request/create', 
      requestBudgetValues
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Request budget hours was sucessfully sent."));
        dispatch(toggleDialogBox(false));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const fetchBudgetRequests = () => {
  return (dispatch) => {
    client().get(
      'budget-request/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let budgetRequests = result.data;
        if (budgetRequests) {
          if (budgetRequests.length === 0) {
            budgetRequests = null;
          }

          dispatch({type: FETCH_BUDGET_REQUESTS, budgetRequests});
        }
        
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const handleFieldChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value;
    if (e) {
      value = {
        [e.target.id]: e.target.value
      }
    }
    else {
      value = definedValue;
    }

    dispatch ({type: SET_REQUEST_BUDGET_FIELD_VALUE, value});
  }
}

